import { useDispatch } from "react-redux";
import { ACTIONS, createDispatchAction } from "src/_config";

export function useAppEventAction() {
  const dispatch = useDispatch();

  return {
    rodeoEvents: createDispatchAction(dispatch, ACTIONS.EVENT.RODEO_EVENTS),
    rodeoEventDetails: createDispatchAction(dispatch, ACTIONS.EVENT.RODEO_EVENT_DETAILS),
    pastRodeoEventDetails: createDispatchAction(dispatch, ACTIONS.EVENT.PAST_RODEO_EVENTS),
    performances: createDispatchAction(dispatch, ACTIONS.EVENT.PERFORMANCES),
    performanceDetails: createDispatchAction(dispatch, ACTIONS.EVENT.PERFORMANCE_DETAILS),
    events: createDispatchAction(dispatch, ACTIONS.EVENT.EVENTS),
    eventDetails: createDispatchAction(dispatch, ACTIONS.EVENT.EVENT_DETAILS),
    gameStatusText: createDispatchAction(dispatch, ACTIONS.EVENT.GAME_STATUS_TEXT),
    rodeoEventStatusText: createDispatchAction(dispatch, ACTIONS.EVENT.RODEO_EVENT_STATUS_TEXT),
    rodeoEventGlow: createDispatchAction(dispatch, ACTIONS.EVENT.RODEO_EVENT_GLOW),
    eventStatusUpdate: createDispatchAction(dispatch, ACTIONS.EVENT.EVENT_STATUS_UPDATE),
    performanceEndAllEvents: createDispatchAction(dispatch, ACTIONS.EVENT.PERFORMANCE_END_ALL_EVENTS),
    performanceStartPick: createDispatchAction(dispatch, ACTIONS.EVENT.PERFORMANCE_START_PICK),
    winnerDeclared: createDispatchAction(dispatch, ACTIONS.EVENT.WINNER_DECLARED),
    groupGlow: createDispatchAction(dispatch, ACTIONS.EVENT.GROUP_EVENT_GLOW),
    applyLeagueCode: createDispatchAction(dispatch, ACTIONS.EVENT.APPLY_LEAGUE_CODE),
  };
}
